import React, { ReactNode, useEffect, useState } from "react";
import "./accordion.scss";

interface AccordionProps {
  controlled?: boolean; // If the parent will provide control by changing `isOpen` prop
  isOpen?: boolean;
  onClick?: (isOpen: boolean) => void;
  title: ReactNode;
}

export const Accordion: React.FC<AccordionProps> = ({ children, controlled, isOpen, onClick, title }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(controlled === true ? isOpen : false);

  useEffect(() => {
    setIsAccordionOpen(Boolean(isOpen));
  }, [isOpen]);

  const handleOnClick = () => {
    const newState = !isAccordionOpen;
    onClick && onClick(newState);

    if (!controlled) {
      setIsAccordionOpen(newState);
    }
  };

  return (
    <div className="c-accordion" data-open={isAccordionOpen}>
      <div className="c-accordion__header" onClick={handleOnClick}>
        {title}
        <img
          src={require("../../../assets/icons/chevron-icn.svg")}
          className="c-accordion__button"
          role="button"
          alt="chevron"
          loading="lazy"
        />
      </div>
      {isAccordionOpen && <div className="c-accordion__content">{children}</div>}
    </div>
  );
};
